import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import {siteConfig} from "../../config/siteConfig";

const ServicesDetailed = ({ services }) => {
    return (
        <Box sx={{ py: 10, bgcolor: 'white' }}>
            <Container maxWidth="xl">
                {/* Title Section */}
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 'bold',
                            mb: 2,
                            color: siteConfig.colors.secondary,
                            '& span': {
                                color: siteConfig.colors.primary
                            }
                        }}
                    >
                        Unsere <span>Leistungen</span>
                    </Typography>

                    {/* Accent Line */}
                    <Box sx={{
                        width: '80px',
                        height: '4px',
                        bgcolor: siteConfig.colors.primary,
                        margin: '0 auto',
                        mb: 3
                    }} />

                    <Typography
                        variant="h6"
                        sx={{
                            color: siteConfig.colors.text,
                            maxWidth: '800px',
                            margin: '0 auto'
                        }}
                    >
                        Wir bieten professionelles Chiptuning für alle Fahrzeugtypen mit individueller Anpassung und Garantie
                    </Typography>
                </Box>

                {/* Services List */}
                <Box sx={{ maxWidth: '1000px', margin: '0 auto' }}>
                    {services.map((service, index) => (
                        <Grid
                            container
                            spacing={4}
                            alignItems="center"
                            key={index}
                            sx={{
                                mb: 6,
                                flexDirection: index % 2 === 0 ? 'row' : 'row-reverse'
                            }}
                        >
                            {/* Icon Column */}
                            <Grid item xs={12} md={2}>
                                <Box
                                    sx={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: '50%',
                                        bgcolor: siteConfig.colors.primary,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 10px 30px rgba(231, 76, 60, 0.3)',
                                        margin: { xs: '0 auto', md: index % 2 === 0 ? '0' : '0 0 0 auto' },
                                        transition: 'transform 0.3s ease',
                                        '&:hover': {
                                            transform: 'scale(1.1)',
                                        }
                                    }}
                                >
                                    {service.icon}
                                </Box>
                            </Grid>

                            {/* Content Column */}
                            <Grid item xs={12} md={10}>
                                <Box
                                    sx={{
                                        textAlign: { xs: 'center', md: index % 2 === 0 ? 'left' : 'right' },
                                        pl: { md: index % 2 === 0 ? 2 : 0 },
                                        pr: { md: index % 2 === 0 ? 0 : 2 }
                                    }}
                                >
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontWeight: 'bold',
                                            mb: 2,
                                            color: siteConfig.colors.secondary
                                        }}
                                    >
                                        {service.title}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: siteConfig.colors.text,
                                            lineHeight: 1.8,
                                            fontSize: '1.1rem'
                                        }}
                                    >
                                        {service.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default ServicesDetailed;